module.exports = __webpack_public_path__ + "static/media/mid_lhs.205ceddd.png";